// The template picker's own-folder groups (2026-10-22): a Website Support
// contact browses the brand's Website library and the same brand's Support
// tree, and the server names the tree to show as its own labelled group
// (GET /api/templates/folders's `groups`, [{ label, prefix }]). These helpers
// only shape the folder list; the server decides what is in it.

// { main, groups }: the folders in no group, in order, then each group with
// its folders ([{ label, prefix, folders }]), a group with none left out.
export function splitOwnFolderGroups(folders, groups) {
  const list = Array.isArray(folders) ? folders : []
  const named = (Array.isArray(groups) ? groups : []).filter((g) => g?.prefix && g?.label)
  const shaped = named.map((g) => ({ label: g.label, prefix: g.prefix, folders: list.filter((f) => f.startsWith(g.prefix)) }))
  const grouped = new Set(shaped.flatMap((g) => g.folders))
  return { main: list.filter((f) => !grouped.has(f)), groups: shaped.filter((g) => g.folders.length > 0) }
}

// A grouped folder's row text under its group header: "CDR" for "1A Support/CDR".
export function groupedFolderLabel(group, folder) {
  return folder.startsWith(group.prefix) ? folder.slice(group.prefix.length) : folder
}
